import { FunctionComponent } from 'react'

import '../styles/Loading.css'

interface LoadingProps {
  isLoading: boolean
}

const Loading: FunctionComponent<LoadingProps> = ({ isLoading }) => {
  return (
    <div className={`loading-component-wrapper ${isLoading ? 'loading' : ''}`}>
      <div className="loading-component-background"></div>
      <div className="my-ant-spin-container">
        <span className="ant-spin-dot ant-spin-dot-spin">
          <i className="ant-spin-dot-item"></i>
          <i className="ant-spin-dot-item"></i>
          <i className="ant-spin-dot-item"></i>
          <i className="ant-spin-dot-item"></i>
        </span>
      </div>
    </div>
  )
}

export default Loading
